/**
 * DreamMee — New Character Pose Configurations
 * Auto-generated by scripts/generate-pose-config.js
 * 
 * Poses: female_gaming, female_gaming_tilted, male_gaming, male_gaming_tilted,
 *        male_pose_1, male_pose_2, male_pose_3
 */

// ==================== NEW POSE DEFINITIONS ====================
// These get merged into CHARACTER_CONFIG.poses at runtime

const NEW_CHARACTER_POSES = [
  // Gaming poses (female)
  {
    id: 'female_gaming',
    name: 'Female Gaming',
    icon: 'demo-assets/characters/preview/pose_icon_female_gaming.png',
    zIndexConfig: [
      'hair_back', 'body', 'socks', 'outfit_bottom', 'outfit_upper',
      'outfit_outer',
      'head', 'eyes', 'brows',
      'handheld', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  {
    id: 'female_gaming_tilted',
    name: 'Female Gaming (Tilted)',
    icon: 'demo-assets/characters/preview/pose_icon_female_gaming.png',
    tiltedOf: 'female_gaming',
    zIndexConfig: [
      'hair_back', 'body', 'socks', 'outfit_bottom', 'outfit_upper',
      'outfit_outer',
      'head', 'eyes', 'brows',
      'handheld', 'mouth', 'nose', 'face_acc',
      'hair_front', 'ears'
    ]
  },
  // Gaming poses (male)
  {
    id: 'male_gaming',
    name: 'Male Gaming',
    icon: 'demo-assets/characters/preview/pose_icon_male_gaming.png',
    zIndexConfig: [
      'body', 'socks', 'outfit_bottom', 'outfit_upper', 'outfit_outer',
      'head', 'eyes', 'brows',
      'handheld', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  {
    id: 'male_gaming_tilted',
    name: 'Male Gaming (Tilted)',
    icon: 'demo-assets/characters/preview/pose_icon_male_gaming.png',
    tiltedOf: 'male_gaming',
    zIndexConfig: [
      'body', 'socks', 'outfit_bottom', 'outfit_upper', 'outfit_outer',
      'head', 'eyes', 'brows',
      'handheld', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  // Male poses
  {
    id: 'male_pose_1',
    name: 'Male Pose 1',
    icon: 'demo-assets/characters/preview/pose_icon_male_pose_1.png',
    zIndexConfig: [
      'hair_back', 'acc_back', 'body', 'shoes', 'outfit_bottom', 'outfit_upper',
      'head', 'eyes', 'brows', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears', 'acc_front'
    ]
  },
  {
    id: 'male_pose_2',
    name: 'Male Pose 2',
    icon: 'demo-assets/characters/preview/pose_icon_male_pose_2.png',
    zIndexConfig: [
      'hair_back', 'body', 'shoes', 'outfit_bottom', 'outfit_upper',
      'head', 'eyes', 'brows', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  {
    id: 'male_pose_3',
    name: 'Male Pose 3',
    icon: 'demo-assets/characters/preview/pose_icon_male_pose_3.png',
    zIndexConfig: [
      'hair_back', 'body', 'shoes', 'outfit_bottom', 'outfit_upper',
      'head', 'eyes', 'brows', 'mouth', 'nose', 'face_acc',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  // They Don't Bite poses
  {
    id: 'female_tdnb',
    name: 'Female (They Don\'t Bite)',
    icon: 'demo-assets/characters/preview/pose_icon_female_tdnb.png',
    canvasSize: { width: 560, height: 460 },  // landscape (source: 2800×2300)
    zIndexConfig: [
      'hair_back', 'body_shadow', 'body', 'outfit_bottom', 'outfit_shirt',
      'outfit_outer', 'head', 'expression', 'makeup',
      'hair_side', 'hair_front', 'ears',
      'socks'
    ]
  },
  {
    id: 'male_tdnb',
    name: 'Male (They Don\'t Bite)',
    icon: 'demo-assets/characters/preview/pose_icon_male_tdnb.png',
    canvasSize: { width: 560, height: 460 },  // landscape (source: 2800×2300)
    zIndexConfig: [
      'body_shadow', 'body', 'outfit_bottom', 'outfit_shirt',
      'outfit_outer', 'head', 'expression',
      'hair_front', 'ears',
      'socks'
    ]
  },
  // I Survived AX poses
  {
    id: 'female_isa',
    name: 'Female (I Survived AX)',
    icon: 'demo-assets/characters/preview/pose_icon_female_isa.png',
    zIndexConfig: [
      'hair_back', 'body', 'socks', 'shoes', 'outfit_bottom', 'outfit_shirt',
      'outfit_outer',
      'head', 'eyes', 'brows',
      'mouth', 'nose', 'face_acc',
      'makeup', 'makeup_lashes', 'makeup_lip', 'makeup_brows',
      'hair_side', 'hair_front', 'ears'
    ]
  },
  {
    id: 'male_isa',
    name: 'Male (I Survived AX)',
    icon: 'demo-assets/characters/preview/pose_icon_male_isa.png',
    zIndexConfig: [
      'body', 'shoes', 'outfit_bottom', 'outfit_shirt',
      'outfit_outer', 'outfit_chain',
      'head', 'eyes', 'brows',
      'mouth', 'nose', 'face_acc',
      'makeup_lashes', 'makeup_lip',
      'hair_front', 'ears'
    ]
  }
];

// ==================== NEW POSE ACCORDION SECTIONS ====================
// Gaming poses need these additional accordion sections
const GAMING_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Skin Tone' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'nose', label: 'Nose' },
      { id: 'mouth', label: 'Mouth' },
      { id: 'eyes', label: 'Eyes' },
      { id: 'brows', label: 'Eyebrows' },
      { id: 'face_acc', label: 'Blush / Makeup' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_set', label: 'Outfit Set', type: 'outfit_set' },
      { id: 'outfit_outer', label: 'Outer' },
      { id: 'outfit_upper', label: 'Upper' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'socks', label: 'Socks' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Front' },
      { id: 'hair_back', label: 'Back' },
      { id: 'hair_side', label: 'Side' }
    ]
  },
  {
    id: 'extras_section',
    label: 'Extras',
    icon: '✨',
    subSections: [
      { id: 'handheld', label: 'Gaming Phone' },
      { id: 'extras', label: 'Accessories' }
    ]
  }
];

// Male poses need these accordion sections
const MALE_POSE_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Skin Tone' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'nose', label: 'Nose' },
      { id: 'mouth', label: 'Mouth' },
      { id: 'eyes', label: 'Eyes' },
      { id: 'brows', label: 'Eyebrows' },
      { id: 'face_acc', label: 'Cheek / Blush' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_set', label: 'Outfit Set', type: 'outfit_set' },
      { id: 'outfit_upper', label: 'Upper' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'shoes', label: 'Shoes' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Front' },
      { id: 'hair_back', label: 'Back' },
      { id: 'hair_side', label: 'Side' }
    ]
  },
  {
    id: 'extras_section',
    label: 'Accessories',
    icon: '✨',
    subSections: [
      { id: 'acc_front', label: 'Front' },
      { id: 'acc_back', label: 'Back' }
    ]
  }
];

// They Don't Bite poses need these accordion sections
const TDNB_FEMALE_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Skin Tone' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'expression', label: 'Expression' },
      { id: 'makeup', label: 'Makeup' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_outer', label: 'Outer (Jacket)' },
      { id: 'outfit_shirt', label: 'Shirt' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'socks', label: 'Socks' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Front' },
      { id: 'hair_back', label: 'Back' },
      { id: 'hair_side', label: 'Side' }
    ]
  }
];

const TDNB_MALE_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Skin Tone' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'expression', label: 'Expression' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_outer', label: 'Outer (Jacket)' },
      { id: 'outfit_shirt', label: 'Shirt' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'socks', label: 'Socks' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Hair' }
    ]
  }
];

// I Survived AX female accordion sections
const ISA_FEMALE_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Body' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'nose', label: 'Nose' },
      { id: 'mouth', label: 'Mouth' },
      { id: 'eyes', label: 'Eyes' },
      { id: 'brows', label: 'Eyebrows' },
      { id: 'face_acc', label: 'Blush' }
    ]
  },
  {
    id: 'makeup_group',
    label: 'Makeup',
    icon: '💄',
    subSections: [
      { id: 'makeup', label: 'Makeup' },
      { id: 'makeup_lashes', label: 'Lashes' },
      { id: 'makeup_lip', label: 'Lip' },
      { id: 'makeup_brows', label: 'Makeup Brows' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_outer', label: 'Outer' },
      { id: 'outfit_shirt', label: 'Shirt' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'shoes', label: 'Shoes' },
      { id: 'socks', label: 'Socks' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Front' },
      { id: 'hair_back', label: 'Back' },
      { id: 'hair_side', label: 'Side' }
    ]
  }
];

// I Survived AX male accordion sections
const ISA_MALE_ACCORDION_SECTIONS = [
  {
    id: 'pose',
    label: 'Pose',
    icon: '🧍',
    type: 'pose'
  },
  {
    id: 'body_group',
    label: 'Body & Skin',
    icon: '👤',
    subSections: [
      { id: 'body', label: 'Body' },
      { id: 'ears', label: 'Ears' },
      { id: 'head', label: 'Head Shape' }
    ]
  },
  {
    id: 'face_group',
    label: 'Expression',
    icon: '😊',
    subSections: [
      { id: 'nose', label: 'Nose' },
      { id: 'mouth', label: 'Mouth' },
      { id: 'eyes', label: 'Eyes' },
      { id: 'brows', label: 'Eyebrows' },
      { id: 'face_acc', label: 'Blush' }
    ]
  },
  {
    id: 'makeup_group',
    label: 'Makeup',
    icon: '💄',
    subSections: [
      { id: 'makeup_lashes', label: 'Lashes' },
      { id: 'makeup_lip', label: 'Lip' }
    ]
  },
  {
    id: 'clothing_group',
    label: 'Outfit',
    icon: '👕',
    subSections: [
      { id: 'outfit_outer', label: 'Outer' },
      { id: 'outfit_shirt', label: 'Shirt' },
      { id: 'outfit_bottom', label: 'Bottom' },
      { id: 'outfit_chain', label: 'Chain' },
      { id: 'shoes', label: 'Shoes' }
    ]
  },
  {
    id: 'hair_group',
    label: 'Hair',
    icon: '💇',
    subSections: [
      { id: 'hair_front', label: 'Hair' }
    ]
  }
];

// Map pose IDs to their accordion section overrides
const POSE_ACCORDION_MAP = {
  'female_gaming': GAMING_ACCORDION_SECTIONS,
  'female_gaming_tilted': GAMING_ACCORDION_SECTIONS,
  'male_gaming': GAMING_ACCORDION_SECTIONS,
  'male_gaming_tilted': GAMING_ACCORDION_SECTIONS,
  'male_pose_1': MALE_POSE_ACCORDION_SECTIONS,
  'male_pose_2': MALE_POSE_ACCORDION_SECTIONS,
  'male_pose_3': MALE_POSE_ACCORDION_SECTIONS,
  'female_tdnb': TDNB_FEMALE_ACCORDION_SECTIONS,
  'male_tdnb': TDNB_MALE_ACCORDION_SECTIONS,
  'female_isa': ISA_FEMALE_ACCORDION_SECTIONS,
  'male_isa': ISA_MALE_ACCORDION_SECTIONS
};

// ==================== NEW POSE ASSETS ====================
const NEW_CHARACTER_ASSETS = {
  // ----- Female Gaming (female-gaming-pose) -----
  // Normal sub-pose:
  fgp_normal: {
    body: [
      { id: 'fgp_body', name: 'Default', src: 'demo-assets/characters/female-gaming-pose/body 1.png' }
    ],
    ears: [
      { id: 'fgp_ears', name: 'Default', src: 'demo-assets/characters/female-gaming-pose/ear 1.png' }
    ],
    brows: [
      { id: 'fgp_brows_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyebrow 1.png' },
      { id: 'fgp_brows_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyebrow 2.png' },
      { id: 'fgp_brows_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyebrow 3.png' },
      { id: 'fgp_brows_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyebrow 4.png' },
      { id: 'fgp_brows_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/female-gaming-pose/exp 2 eyebrow 1.png' },
      { id: 'fgp_brows_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/female-gaming-pose/exp 2 eyebrow 2.png' },
      { id: 'fgp_brows_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/female-gaming-pose/exp 2 eyebrow 3.png' },
      { id: 'fgp_brows_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/female-gaming-pose/exp 2 eyebrow 4.png' },
      { id: 'fgp_brows_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyebrow 1.png' },
      { id: 'fgp_brows_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyebrow 2.png' },
      { id: 'fgp_brows_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyebrow 3.png' },
      { id: 'fgp_brows_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyebrow 4.png' }
    ],
    eyes: [
      { id: 'fgp_eyes_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyes 1.png' },
      { id: 'fgp_eyes_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyes 2.png' },
      { id: 'fgp_eyes_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyes 3.png' },
      { id: 'fgp_eyes_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyes 4.png' },
      { id: 'fgp_eyes_e1_v5', name: 'Exp 1 #5', src: 'demo-assets/characters/female-gaming-pose/exp 1 eyes 5.png' },
      { id: 'fgp_eyes_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/female-gaming-pose/exp 2 eyes.png' },
      { id: 'fgp_eyes_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyes 1.png' },
      { id: 'fgp_eyes_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyes 2.png' },
      { id: 'fgp_eyes_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyes 3.png' },
      { id: 'fgp_eyes_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyes 4.png' },
      { id: 'fgp_eyes_e3_v5', name: 'Exp 3 #5', src: 'demo-assets/characters/female-gaming-pose/exp 3 eyes 5.png' }
    ],
    mouth: [
      { id: 'fgp_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/female-gaming-pose/exp 1 mouth.png' },
      { id: 'fgp_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/female-gaming-pose/exp 2 mouth.png' },
      { id: 'fgp_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/female-gaming-pose/exp 3 mouth.png' }
    ],
    face_acc: [
      { id: 'fgp_normal_face_acc_none', name: 'None', src: null },
      { id: 'fgp_face_acc_e2_blush', name: 'Exp 2 Blush', src: 'demo-assets/characters/female-gaming-pose/exp 2 blush.png' },
      { id: 'fgp_face_acc_crying', name: 'Crying', src: 'demo-assets/characters/female-gaming-pose/make up crying 1.png' },
      { id: 'fgp_face_acc_focus', name: 'Focus', src: 'demo-assets/characters/female-gaming-pose/make up focus 1.png' },
      { id: 'fgp_face_acc_judging', name: 'Judging', src: 'demo-assets/characters/female-gaming-pose/make up judging 1.png' }
    ],
    hair_back: [
      { id: 'fgp_normal_hair_back_none', name: 'None', src: null },
      { id: 'fgp_hair_back_s1', name: 'Style 1', src: 'demo-assets/characters/female-gaming-pose/hair 1 back.png' },
      { id: 'fgp_hair_back_s3', name: 'Style 3', src: 'demo-assets/characters/female-gaming-pose/hair 3 back.png' },
      { id: 'fgp_hair_back_s5', name: 'Style 5', src: 'demo-assets/characters/female-gaming-pose/hair 5 back.png' },
      { id: 'fgp_hair_back_s6', name: 'Style 6', src: 'demo-assets/characters/female-gaming-pose/hair 6 back.png' },
      { id: 'fgp_hair_back_s7', name: 'Style 7', src: 'demo-assets/characters/female-gaming-pose/hair 7 back.png' },
      { id: 'fgp_hair_back_s9', name: 'Style 9', src: 'demo-assets/characters/female-gaming-pose/hair 9 back.png' }
    ],
    hair_front: [
      { id: 'fgp_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/female-gaming-pose/hair 1 front.png' },
      { id: 'fgp_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/female-gaming-pose/hair 2 front.png' },
      { id: 'fgp_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/female-gaming-pose/hair 3 front.png' },
      { id: 'fgp_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/female-gaming-pose/hair 4 front.png' },
      { id: 'fgp_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/female-gaming-pose/hair 5 front.png' },
      { id: 'fgp_hair_front_s6', name: 'Style 6', src: 'demo-assets/characters/female-gaming-pose/hair 6 front.png' },
      { id: 'fgp_hair_front_s7', name: 'Style 7', src: 'demo-assets/characters/female-gaming-pose/hair 7 front.png' },
      { id: 'fgp_hair_front_s8', name: 'Style 8', src: 'demo-assets/characters/female-gaming-pose/hair 8 front.png' },
      { id: 'fgp_hair_front_s9', name: 'Style 9', src: 'demo-assets/characters/female-gaming-pose/hair 9 front.png' }
    ],
    hair_side: [
      { id: 'fgp_normal_hair_side_none', name: 'None', src: null },
      { id: 'fgp_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/female-gaming-pose/hair 2 side.png' },
      { id: 'fgp_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/female-gaming-pose/hair 4 side.png' },
      { id: 'fgp_hair_side_s6', name: 'Style 6', src: 'demo-assets/characters/female-gaming-pose/hair 6 side.png' },
      { id: 'fgp_hair_side_s8', name: 'Style 8', src: 'demo-assets/characters/female-gaming-pose/hair 8 side.png' }
    ],
    handheld: [
      { id: 'fgp_normal_handheld_none', name: 'None', src: null },
      { id: 'fgp_handheld', name: 'Default', src: 'demo-assets/characters/female-gaming-pose/hand held gaming phone.png' }
    ],
    head: [
      { id: 'fgp_head_normal', name: 'Normal', src: 'demo-assets/characters/female-gaming-pose/head normal 1.png' },
      { id: 'fgp_head_fat', name: 'Fat', src: 'demo-assets/characters/female-gaming-pose/head fat 1.png' },
      { id: 'fgp_head_narrow', name: 'Narrow', src: 'demo-assets/characters/female-gaming-pose/head narrow 1.png' },
      { id: 'fgp_head_square', name: 'Square', src: 'demo-assets/characters/female-gaming-pose/head square 1.png' }
    ],

    nose: [
      { id: 'fgp_nose_v1', name: '#1', src: 'demo-assets/characters/female-gaming-pose/nose 1.png' },
      { id: 'fgp_nose_v2', name: '#2', src: 'demo-assets/characters/female-gaming-pose/nose 2.png' }
    ],
    outfit_bottom: [
      { id: 'fgp_outfit_bottom_set1', name: 'Set 1', src: 'demo-assets/characters/female-gaming-pose/outfit 1 bot.png' },
      { id: 'fgp_outfit_bottom_set2', name: 'Set 2', src: 'demo-assets/characters/female-gaming-pose/outfit 2 bot.png' },
      { id: 'fgp_outfit_bottom_set3', name: 'Set 3', src: 'demo-assets/characters/female-gaming-pose/outfit 3 bot.png' },
      { id: 'fgp_outfit_bottom_set4', name: 'Set 4', src: 'demo-assets/characters/female-gaming-pose/outfit 4 bot.png' }
    ],
    socks: [
      { id: 'fgp_normal_socks_none', name: 'None', src: null },
      { id: 'fgp_socks_set1', name: 'Set 1', src: 'demo-assets/characters/female-gaming-pose/outfit 1 shocks.png' },
      { id: 'fgp_socks_set2', name: 'Set 2', src: 'demo-assets/characters/female-gaming-pose/outfit 2 shocks.png' },
      { id: 'fgp_socks_set3', name: 'Set 3', src: 'demo-assets/characters/female-gaming-pose/outfit 3 shocks.png' },
      { id: 'fgp_socks_vdefault', name: '#default', src: 'demo-assets/characters/female-gaming-pose/shocks.png' }
    ],
    outfit_outer: [
      { id: 'fgp_normal_outfit_outer_none', name: 'None', src: null },
      { id: 'fgp_outfit_outer_set1', name: 'Set 1', src: 'demo-assets/characters/female-gaming-pose/outfit 1 top.png' },
      { id: 'fgp_outfit_outer_set2', name: 'Set 2', src: 'demo-assets/characters/female-gaming-pose/outfit 2 top.png' },
      { id: 'fgp_outfit_outer_set3', name: 'Set 3', src: 'demo-assets/characters/female-gaming-pose/outfit 3 top.png' },
      { id: 'fgp_outfit_outer_set4', name: 'Set 4', src: 'demo-assets/characters/female-gaming-pose/outfit 4 top.png' }
    ],
    outfit_upper: [
      { id: 'fgp_outfit_upper_set2', name: 'Set 2', src: 'demo-assets/characters/female-gaming-pose/outfit 2 shirt.png' },
      { id: 'fgp_outfit_upper_set3', name: 'Set 3', src: 'demo-assets/characters/female-gaming-pose/outfit 3 shirt.png' },
      { id: 'fgp_outfit_upper_set4', name: 'Set 4', src: 'demo-assets/characters/female-gaming-pose/outfit 4 shirt.png' }
    ],
    outfit_full: [
      { id: 'fgp_outfit_full_set5', name: 'Set 5', src: 'demo-assets/characters/female-gaming-pose/outfit 5.png' }
    ],
    outfit_bottom: [
      { id: 'fgp_normal_sim_bottom_none', name: 'None', src: null },
      { id: 'fgp_s_bottom_set1_bottom_v1', name: 'Set 1 Bottom', src: 'demo-assets/characters/female-gaming-pose/sim outfit 1 bottom 1.png' },
      { id: 'fgp_s_bottom_set2_bottom_v1', name: 'Set 2 Bottom', src: 'demo-assets/characters/female-gaming-pose/sim outfit 2 bottom 1.png' },
      { id: 'fgp_s_bottom_set3_bottom_v1', name: 'Set 3 Bottom', src: 'demo-assets/characters/female-gaming-pose/sim outfit 3 bottom 1.png' },
      { id: 'fgp_s_bottom_set4_bottom_v1', name: 'Set 4 Bottom', src: 'demo-assets/characters/female-gaming-pose/sim outfit 4 bottom 1.png' },
      { id: 'fgp_s_bottom_set5_bottom_v1', name: 'Set 5 Bottom', src: 'demo-assets/characters/female-gaming-pose/sim outfit 5 bottom 1.png' },
    ],
    outfit_acc: [
      { id: 'fgp_normal_sim_acc_none', name: 'None', src: null },
      { id: 'fgp_s_acc_set1_chain_v1', name: 'Set 1 Chain #1', src: 'demo-assets/characters/female-gaming-pose/sim outfit 1 chain.png' },
      { id: 'fgp_s_acc_set3_trench_v1', name: 'Set 3 Trench #1', src: 'demo-assets/characters/female-gaming-pose/sim outfit 3 trench.png' },
      { id: 'fgp_s_acc_set5_hoodie_v1', name: 'Set 5 Hoodie #1', src: 'demo-assets/characters/female-gaming-pose/sim outfit 5 hoodie.png' }
    ],
    outfit_outer: [
      { id: 'fgp_normal_sim_outer_none', name: 'None', src: null },
      { id: 'fgp_s_outer_set1_jacket_v1', name: 'Set 1 Jacket', src: 'demo-assets/characters/female-gaming-pose/sim outfit 1 jacket 1.png' },
      { id: 'fgp_s_outer_set2_sweater_v1', name: 'Set 2 Sweater', src: 'demo-assets/characters/female-gaming-pose/sim outfit 2 sweater 1.png' },
      { id: 'fgp_s_outer_set3_sweater_v1', name: 'Set 3 Sweater', src: 'demo-assets/characters/female-gaming-pose/sim outfit 3 sweater 1.png' },
    ],
    outfit_upper: [
      { id: 'fgp_normal_sim_upper_none', name: 'None', src: null },
      { id: 'fgp_s_upper_set1_upper_v1', name: 'Set 1 Upper', src: 'demo-assets/characters/female-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'fgp_s_upper_set2_upper_v1', name: 'Set 2 Upper', src: 'demo-assets/characters/female-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'fgp_s_upper_set3_upper_v1', name: 'Set 3 Upper', src: 'demo-assets/characters/female-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'fgp_s_upper_set4_upper_v1', name: 'Set 4 Upper', src: 'demo-assets/characters/female-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'fgp_s_upper_set5_upper_v1', name: 'Set 5 Upper', src: 'demo-assets/characters/female-gaming-pose/sim outfit 5 upper 1.png' },
    ],
  },
  // Tilted sub-pose:
  fgp_tilted: {
    ears: [
      { id: 'fgp_t_ears', name: 'Default', src: 'demo-assets/characters/female-gaming-pose/tilted ear 1.png' }
    ],
    brows: [
      { id: 'fgp_t_brows_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyebrow 1.png' },
      { id: 'fgp_t_brows_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyebrow 2.png' },
      { id: 'fgp_t_brows_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyebrow 3.png' },
      { id: 'fgp_t_brows_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyebrow 4.png' },
      { id: 'fgp_t_brows_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyebrow 1.png' },
      { id: 'fgp_t_brows_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyebrow 2.png' },
      { id: 'fgp_t_brows_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyebrow 3.png' },
      { id: 'fgp_t_brows_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyebrow 4.png' },
      { id: 'fgp_t_brows_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 eyebrow 1.png' },
      { id: 'fgp_t_brows_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 eyebrow 2.png' },
      { id: 'fgp_t_brows_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 eyebrow 3.png' },
      { id: 'fgp_t_brows_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 eyebrow 4.png' }
    ],
    eyes: [
      { id: 'fgp_t_eyes_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyes 1.png' },
      { id: 'fgp_t_eyes_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyes 2.png' },
      { id: 'fgp_t_eyes_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyes 3.png' },
      { id: 'fgp_t_eyes_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyes 4.png' },
      { id: 'fgp_t_eyes_e1_v5', name: 'Exp 1 #5', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 eyes 5.png' },
      { id: 'fgp_t_eyes_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyes 1.png' },
      { id: 'fgp_t_eyes_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyes 2.png' },
      { id: 'fgp_t_eyes_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyes 3.png' },
      { id: 'fgp_t_eyes_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyes 4.png' },
      { id: 'fgp_t_eyes_e2_v5', name: 'Exp 2 #5', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 eyes 5.png' },
      { id: 'fgp_t_eyes_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 eyes.png' }
    ],
    mouth: [
      { id: 'fgp_t_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/female-gaming-pose/tilted exp 1 mouth.png' },
      { id: 'fgp_t_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/female-gaming-pose/tilted exp 2 mouth.png' },
      { id: 'fgp_t_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 mouth.png' }
    ],
    face_acc: [
      { id: 'fgp_tilted_face_acc_none', name: 'None', src: null },
      { id: 'fgp_t_face_acc_e3_blush', name: 'Exp 3 Blush', src: 'demo-assets/characters/female-gaming-pose/tilted exp 3 blush.png' },
      { id: 'fgp_t_face_acc_crying', name: 'Crying', src: 'demo-assets/characters/female-gaming-pose/tilted make up crying 1.png' },
      { id: 'fgp_t_face_acc_focus', name: 'Focus', src: 'demo-assets/characters/female-gaming-pose/tilted make up focus 1.png' },
      { id: 'fgp_t_face_acc_judging', name: 'Judging', src: 'demo-assets/characters/female-gaming-pose/tilted make up judging 1.png' }
    ],
    head: [
      { id: 'fgp_t_head_normal', name: 'Normal', src: 'demo-assets/characters/female-gaming-pose/tilted normal head 1.png' },
      { id: 'fgp_t_head_fat', name: 'Fat', src: 'demo-assets/characters/female-gaming-pose/tilted fat head 1.png' },
      { id: 'fgp_t_head_narrow', name: 'Narrow', src: 'demo-assets/characters/female-gaming-pose/tilted narrow head 1.png' },
      { id: 'fgp_t_head_square', name: 'Square', src: 'demo-assets/characters/female-gaming-pose/tilted square head 1.png' }
    ],
    hair_back: [
      { id: 'fgp_tilted_hair_back_none', name: 'None', src: null },
      { id: 'fgp_t_hair_back_s1', name: 'Style 1', src: 'demo-assets/characters/female-gaming-pose/tilted hair 1 back.png' },
      { id: 'fgp_t_hair_back_s3', name: 'Style 3', src: 'demo-assets/characters/female-gaming-pose/tilted hair 3 back.png' },
      { id: 'fgp_t_hair_back_s5', name: 'Style 5', src: 'demo-assets/characters/female-gaming-pose/tilted hair 5 back.png' },
      { id: 'fgp_t_hair_back_s6', name: 'Style 6', src: 'demo-assets/characters/female-gaming-pose/tilted hair 6 back.png' },
      { id: 'fgp_t_hair_back_s7', name: 'Style 7', src: 'demo-assets/characters/female-gaming-pose/tilted hair 7 back.png' },
      { id: 'fgp_t_hair_back_s9', name: 'Style 9', src: 'demo-assets/characters/female-gaming-pose/tilted hair 9 back.png' }
    ],
    hair_front: [
      { id: 'fgp_t_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/female-gaming-pose/tilted hair 1 front.png' },
      { id: 'fgp_t_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/female-gaming-pose/tilted hair 2 front.png' },
      { id: 'fgp_t_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/female-gaming-pose/tilted hair 3 front.png' },
      { id: 'fgp_t_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/female-gaming-pose/tilted hair 4 front.png' },
      { id: 'fgp_t_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/female-gaming-pose/tilted hair 5 front.png' },
      { id: 'fgp_t_hair_front_s6', name: 'Style 6', src: 'demo-assets/characters/female-gaming-pose/tilted hair 6 front.png' },
      { id: 'fgp_t_hair_front_s7', name: 'Style 7', src: 'demo-assets/characters/female-gaming-pose/tilted hair 7 front.png' },
      { id: 'fgp_t_hair_front_s8', name: 'Style 8', src: 'demo-assets/characters/female-gaming-pose/tilted hair 8 front.png' },
      { id: 'fgp_t_hair_front_s9', name: 'Style 9', src: 'demo-assets/characters/female-gaming-pose/tilted hair 9 front.png' }
    ],
    nose: [
      { id: 'fgp_t_nose_v1', name: '#1', src: 'demo-assets/characters/female-gaming-pose/tilted nose 1.png' },
      { id: 'fgp_t_nose_v2', name: '#2', src: 'demo-assets/characters/female-gaming-pose/tilted nose 2.png' }
    ],
  },
  // ----- Male Gaming (male-gaming-pose) -----
  // Normal sub-pose:
  mgp_normal: {
    body: [
      { id: 'mgp_body', name: 'Default', src: 'demo-assets/characters/male-gaming-pose/body 1.png' }
    ],
    ears: [
      { id: 'mgp_ears', name: 'Default', src: 'demo-assets/characters/male-gaming-pose/ear 1.png' }
    ],
    brows: [
      { id: 'mgp_brows_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyebrow 1.png' },
      { id: 'mgp_brows_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyebrow 2.png' },
      { id: 'mgp_brows_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyebrow 3.png' },
      { id: 'mgp_brows_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyebrow 4.png' },
      { id: 'mgp_brows_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/male-gaming-pose/exp 2 eyebrow 1.png' },
      { id: 'mgp_brows_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/male-gaming-pose/exp 2 eyebrow 2.png' },
      { id: 'mgp_brows_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/male-gaming-pose/exp 2 eyebrow 3.png' },
      { id: 'mgp_brows_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/male-gaming-pose/exp 2 eyebrow 4.png' },
      { id: 'mgp_brows_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyebrow 1.png' },
      { id: 'mgp_brows_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyebrow 2.png' },
      { id: 'mgp_brows_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyebrow 3.png' },
      { id: 'mgp_brows_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyebrow 4.png' }
    ],
    eyes: [
      { id: 'mgp_eyes_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyes 1.png' },
      { id: 'mgp_eyes_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyes 2.png' },
      { id: 'mgp_eyes_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyes 3.png' },
      { id: 'mgp_eyes_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyes 4.png' },
      { id: 'mgp_eyes_e1_v5', name: 'Exp 1 #5', src: 'demo-assets/characters/male-gaming-pose/exp 1 eyes 5.png' },
      { id: 'mgp_eyes_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/male-gaming-pose/exp 2 eyes.png' },
      { id: 'mgp_eyes_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyes 1.png' },
      { id: 'mgp_eyes_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyes 2.png' },
      { id: 'mgp_eyes_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyes 3.png' },
      { id: 'mgp_eyes_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyes 4.png' },
      { id: 'mgp_eyes_e3_v5', name: 'Exp 3 #5', src: 'demo-assets/characters/male-gaming-pose/exp 3 eyes 5.png' }
    ],
    mouth: [
      { id: 'mgp_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/male-gaming-pose/exp 1 mouth.png' },
      { id: 'mgp_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/male-gaming-pose/exp 2 mouth.png' },
      { id: 'mgp_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/male-gaming-pose/exp 3 mouth.png' }
    ],
    face_acc: [
      { id: 'mgp_normal_face_acc_none', name: 'None', src: null },
      { id: 'mgp_face_acc_e2_blush', name: 'Exp 2 Blush', src: 'demo-assets/characters/male-gaming-pose/exp 2 blush.png' }
    ],
    hair_front: [
      { id: 'mgp_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/male-gaming-pose/hair 1 front.png' },
      { id: 'mgp_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/male-gaming-pose/hair 2 front.png' },
      { id: 'mgp_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/male-gaming-pose/hair 3 front.png' },
      { id: 'mgp_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/male-gaming-pose/hair 4 front.png' },
      { id: 'mgp_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/male-gaming-pose/hair 5 front.png' }
    ],
    hair_side: [
      { id: 'mgp_normal_hair_side_none', name: 'None', src: null },
      { id: 'mgp_hair_side_s1', name: 'Style 1', src: 'demo-assets/characters/male-gaming-pose/hair 1 side.png' },
      { id: 'mgp_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/male-gaming-pose/hair 2 side.png' },
      { id: 'mgp_hair_side_s3', name: 'Style 3', src: 'demo-assets/characters/male-gaming-pose/hair 3 side.png' },
      { id: 'mgp_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/male-gaming-pose/hair 4 side.png' },
      { id: 'mgp_hair_side_s5', name: 'Style 5', src: 'demo-assets/characters/male-gaming-pose/hair 5 side.png' }
    ],
    handheld: [
      { id: 'mgp_normal_handheld_none', name: 'None', src: null },
      { id: 'mgp_handheld', name: 'Default', src: 'demo-assets/characters/male-gaming-pose/hand held gaming phone.png' }
    ],
    head: [
      { id: 'mgp_head_normal', name: 'Normal', src: 'demo-assets/characters/male-gaming-pose/head normal 1.png' },
      { id: 'mgp_head_fat', name: 'Fat', src: 'demo-assets/characters/male-gaming-pose/head fat 1.png' },
      { id: 'mgp_head_narrow', name: 'Narrow', src: 'demo-assets/characters/male-gaming-pose/head narrow 1.png' },
      { id: 'mgp_head_square', name: 'Square', src: 'demo-assets/characters/male-gaming-pose/head square 1.png' }
    ],

    nose: [
      { id: 'mgp_nose_v1', name: '#1', src: 'demo-assets/characters/male-gaming-pose/nose 1.png' },
      { id: 'mgp_nose_v2', name: '#2', src: 'demo-assets/characters/male-gaming-pose/nose 2.png' }
    ],
    socks: [
      { id: 'mgp_normal_socks_none', name: 'None', src: null },
      { id: 'mgp_socks_vdefault', name: '#default', src: 'demo-assets/characters/male-gaming-pose/shocks.png' }
    ],
    outfit_bottom: [
      { id: 'mgp_normal_sim_bottom_none', name: 'None', src: null },
      { id: 'mgp_s_bottom_set1_bottom_v1', name: 'Set 1 Bottom', src: 'demo-assets/characters/male-gaming-pose/sim outfit 1 bottom 1.png' },
      { id: 'mgp_s_bottom_set2_bottom_v1', name: 'Set 2 Bottom', src: 'demo-assets/characters/male-gaming-pose/sim outfit 2 bottom 1.png' },
      { id: 'mgp_s_bottom_set3_bottom_v1', name: 'Set 3 Bottom', src: 'demo-assets/characters/male-gaming-pose/sim outfit 3 bottom 1.png' },
      { id: 'mgp_s_bottom_set4_bottom_v1', name: 'Set 4 Bottom', src: 'demo-assets/characters/male-gaming-pose/sim outfit 4 bottom 1.png' },
      { id: 'mgp_s_bottom_set5_bottom_v1', name: 'Set 5 Bottom', src: 'demo-assets/characters/male-gaming-pose/sim outfit 5 bottom 1.png' },
    ],
    outfit_acc: [
      { id: 'mgp_normal_sim_acc_none', name: 'None', src: null },
      { id: 'mgp_s_acc_set1_chain_v1', name: 'Set 1 Chain #1', src: 'demo-assets/characters/male-gaming-pose/sim outfit 1 chain.png' },
      { id: 'mgp_s_acc_set3_trench_v1', name: 'Set 3 Trench #1', src: 'demo-assets/characters/male-gaming-pose/sim outfit 3 trench.png' },
      { id: 'mgp_s_acc_set5_hoodie_v1', name: 'Set 5 Hoodie #1', src: 'demo-assets/characters/male-gaming-pose/sim outfit 5 hoodie.png' }
    ],
    outfit_outer: [
      { id: 'mgp_normal_sim_outer_none', name: 'None', src: null },
      { id: 'mgp_s_outer_set1_jacket_v1', name: 'Set 1 Jacket', src: 'demo-assets/characters/male-gaming-pose/sim outfit 1 jacket 1.png' },
      { id: 'mgp_s_outer_set2_sweater_v1', name: 'Set 2 Sweater', src: 'demo-assets/characters/male-gaming-pose/sim outfit 2 sweater 1.png' },
      { id: 'mgp_s_outer_set3_sweater_v1', name: 'Set 3 Sweater', src: 'demo-assets/characters/male-gaming-pose/sim outfit 3 sweater 1.png' },
    ],
    outfit_upper: [
      { id: 'mgp_normal_sim_upper_none', name: 'None', src: null },
      { id: 'mgp_s_upper_set1_upper_v1', name: 'Set 1 Upper', src: 'demo-assets/characters/male-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'mgp_s_upper_set2_upper_v1', name: 'Set 2 Upper', src: 'demo-assets/characters/male-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'mgp_s_upper_set3_upper_v1', name: 'Set 3 Upper', src: 'demo-assets/characters/male-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'mgp_s_upper_set4_upper_v1', name: 'Set 4 Upper', src: 'demo-assets/characters/male-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'mgp_s_upper_set5_upper_v1', name: 'Set 5 Upper', src: 'demo-assets/characters/male-gaming-pose/sim outfit 5 upper 1.png' },
    ],
  },
  // Tilted sub-pose:
  mgp_tilted: {
    ears: [
      { id: 'mgp_t_ears', name: 'Default', src: 'demo-assets/characters/male-gaming-pose/tilted ear 1.png' }
    ],
    brows: [
      { id: 'mgp_t_brows_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyebrow 1.png' },
      { id: 'mgp_t_brows_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyebrow 2.png' },
      { id: 'mgp_t_brows_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyebrow 3.png' },
      { id: 'mgp_t_brows_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyebrow 4.png' },
      { id: 'mgp_t_brows_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyebrow 1.png' },
      { id: 'mgp_t_brows_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyebrow 2.png' },
      { id: 'mgp_t_brows_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyebrow 3.png' },
      { id: 'mgp_t_brows_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyebrow 4.png' },
      { id: 'mgp_t_brows_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 eyebrow 1.png' },
      { id: 'mgp_t_brows_e3_v2', name: 'Exp 3 #2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 eyebrow 2.png' },
      { id: 'mgp_t_brows_e3_v3', name: 'Exp 3 #3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 eyebrow 3.png' },
      { id: 'mgp_t_brows_e3_v4', name: 'Exp 3 #4', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 eyebrow 4.png' }
    ],
    eyes: [
      { id: 'mgp_t_eyes_e1_v1', name: 'Exp 1 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyes 1.png' },
      { id: 'mgp_t_eyes_e1_v2', name: 'Exp 1 #2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyes 2.png' },
      { id: 'mgp_t_eyes_e1_v3', name: 'Exp 1 #3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyes 3.png' },
      { id: 'mgp_t_eyes_e1_v4', name: 'Exp 1 #4', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyes 4.png' },
      { id: 'mgp_t_eyes_e1_v5', name: 'Exp 1 #5', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 eyes 5.png' },
      { id: 'mgp_t_eyes_e2_v1', name: 'Exp 2 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyes 1.png' },
      { id: 'mgp_t_eyes_e2_v2', name: 'Exp 2 #2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyes 2.png' },
      { id: 'mgp_t_eyes_e2_v3', name: 'Exp 2 #3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyes 3.png' },
      { id: 'mgp_t_eyes_e2_v4', name: 'Exp 2 #4', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyes 4.png' },
      { id: 'mgp_t_eyes_e2_v5', name: 'Exp 2 #5', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 eyes 5.png' },
      { id: 'mgp_t_eyes_e3_v1', name: 'Exp 3 #1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 eyes.png' }
    ],
    mouth: [
      { id: 'mgp_t_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/male-gaming-pose/tilted exp 1 mouth.png' },
      { id: 'mgp_t_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/male-gaming-pose/tilted exp 2 mouth.png' },
      { id: 'mgp_t_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 mouth.png' }
    ],
    face_acc: [
      { id: 'mgp_tilted_face_acc_none', name: 'None', src: null },
      { id: 'mgp_t_face_acc_e3_blush', name: 'Exp 3 Blush', src: 'demo-assets/characters/male-gaming-pose/tilted exp 3 blush.png' }
    ],
    head: [
      { id: 'mgp_t_head_normal', name: 'Normal', src: 'demo-assets/characters/male-gaming-pose/tilted normal head 1.png' },
      { id: 'mgp_t_head_fat', name: 'Fat', src: 'demo-assets/characters/male-gaming-pose/tilted fat head 1.png' },
      { id: 'mgp_t_head_narrow', name: 'Narrow', src: 'demo-assets/characters/male-gaming-pose/tilted narrow head 1.png' },
      { id: 'mgp_t_head_square', name: 'Square', src: 'demo-assets/characters/male-gaming-pose/tilted square head 1.png' }
    ],
    hair_front: [
      { id: 'mgp_t_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/male-gaming-pose/tilted hair 1 front.png' },
      { id: 'mgp_t_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/male-gaming-pose/tilted hair 2 front.png' },
      { id: 'mgp_t_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/male-gaming-pose/tilted hair 3 front.png' },
      { id: 'mgp_t_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/male-gaming-pose/tilted hair 4 front.png' },
      { id: 'mgp_t_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/male-gaming-pose/tilted hair 5 front.png' }
    ],
    hair_side: [
      { id: 'mgp_tilted_hair_side_none', name: 'None', src: null },
      { id: 'mgp_t_hair_side_s1', name: 'Style 1', src: 'demo-assets/characters/male-gaming-pose/tilted hair 1 side.png' },
      { id: 'mgp_t_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/male-gaming-pose/tilted hair 2 side.png' },
      { id: 'mgp_t_hair_side_s3', name: 'Style 3', src: 'demo-assets/characters/male-gaming-pose/tilted hair 3 side.png' },
      { id: 'mgp_t_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/male-gaming-pose/tilted hair 4 side.png' },
      { id: 'mgp_t_hair_side_s5', name: 'Style 5', src: 'demo-assets/characters/male-gaming-pose/tilted hair 5 side.png' }
    ],
    nose: [
      { id: 'mgp_t_nose_v1', name: '#1', src: 'demo-assets/characters/male-gaming-pose/tilted nose 1.png' },
      { id: 'mgp_t_nose_v2', name: '#2', src: 'demo-assets/characters/male-gaming-pose/tilted nose 2.png' }
    ],
  },
  // ----- Male Pose 1 (male-pose-1) -----
  mp1: {
    acc_back: [
      { id: 'mp1_acc_back_none', name: 'None', src: null },
      { id: 'mp1_acc_back_v1', name: '#1', src: 'demo-assets/characters/male-pose-1/acc back 1.png' },
      { id: 'mp1_acc_back_v2', name: '#2', src: 'demo-assets/characters/male-pose-1/acc back 2.png' },
      { id: 'mp1_acc_back_v3', name: '#3', src: 'demo-assets/characters/male-pose-1/acc back 3.png' }
    ],
    acc_front: [
      { id: 'mp1_acc_front_none', name: 'None', src: null },
      { id: 'mp1_acc_front_v1', name: '#1', src: 'demo-assets/characters/male-pose-1/acc front 1.png' },
      { id: 'mp1_acc_front_v2', name: '#2', src: 'demo-assets/characters/male-pose-1/acc front 2.png' },
      { id: 'mp1_acc_front_v3', name: '#3', src: 'demo-assets/characters/male-pose-1/acc front 3.png' }
    ],
    outfit_bottom: [
      { id: 'mp1_adv_bottom_none', name: 'None', src: null },
      { id: 'mp1_a_bottom_set1_vdefault', name: 'Set 1', src: 'demo-assets/characters/male-pose-1/adv outfit 1 bottom.png' },
      { id: 'mp1_a_bottom_set2_vdefault', name: 'Set 2', src: 'demo-assets/characters/male-pose-1/adv outfit 2 bottom.png' },
      { id: 'mp1_a_bottom_set3_vdefault', name: 'Set 3', src: 'demo-assets/characters/male-pose-1/adv outfit 3 bottom.png' },
      { id: 'mp1_a_bottom_set4_vdefault', name: 'Set 4', src: 'demo-assets/characters/male-pose-1/adv outfit 4 bottom.png' },
      { id: 'mp1_a_bottom_set5_vdefault', name: 'Set 5', src: 'demo-assets/characters/male-pose-1/adv outfit 5 bottom.png' }
    ],
    hair_back: [
      { id: 'mp1_hair_back_none', name: 'None', src: null },
      { id: 'mp1_a_hair_back_set1_vdefault', name: 'Set 1', src: 'demo-assets/characters/male-pose-1/adv outfit 1 hair back.png' },
      { id: 'mp1_a_hair_back_set2_vdefault', name: 'Set 2', src: 'demo-assets/characters/male-pose-1/adv outfit 2 hair back.png' },
      { id: 'mp1_a_hair_back_set3_vdefault', name: 'Set 3', src: 'demo-assets/characters/male-pose-1/adv outfit 3 hair back.png' },
      { id: 'mp1_a_hair_back_set4_vdefault', name: 'Set 4', src: 'demo-assets/characters/male-pose-1/adv outfit 4 hair back.png' },
      { id: 'mp1_a_hair_back_set5_vdefault', name: 'Set 5', src: 'demo-assets/characters/male-pose-1/adv outfit 5 hair back.png' }
    ],
    shoes: [
      { id: 'mp1_shoes_none', name: 'None', src: null },
      { id: 'mp1_a_shoes_set1_vdefault', name: 'Set 1', src: 'demo-assets/characters/male-pose-1/adv outfit 1 shoes.png' },
      { id: 'mp1_a_shoes_set2_vdefault', name: 'Set 2', src: 'demo-assets/characters/male-pose-1/adv outfit 2 shoes.png' },
      { id: 'mp1_a_shoes_set3_vdefault', name: 'Set 3', src: 'demo-assets/characters/male-pose-1/adv outfit 3 shoes.png' },
      { id: 'mp1_a_shoes_set4_vdefault', name: 'Set 4', src: 'demo-assets/characters/male-pose-1/adv outfit 4 shoes.png' },
      { id: 'mp1_a_shoes_set5_vdefault', name: 'Set 5', src: 'demo-assets/characters/male-pose-1/adv outfit 5 shoes.png' }
    ],
    outfit_upper: [
      { id: 'mp1_adv_upper_none', name: 'None', src: null },
      { id: 'mp1_a_upper_set1_vdefault', name: 'Set 1', src: 'demo-assets/characters/male-pose-1/adv outfit 1 upper.png' },
      { id: 'mp1_a_upper_set2_vfat_skin_1', name: 'Set 2 #fat skin 1', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper fat skin 1.png' },
      { id: 'mp1_a_upper_set2_vfat_skin_2', name: 'Set 2 #fat skin 2', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper fat skin 2.png' },
      { id: 'mp1_a_upper_set2_vfat_skin_3', name: 'Set 2 #fat skin 3', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper fat skin 3.png' },
      { id: 'mp1_a_upper_set2_vfat_skin_4', name: 'Set 2 #fat skin 4', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper fat skin 4.png' },
      { id: 'mp1_a_upper_set2_vfat_skin_5', name: 'Set 2 #fat skin 5', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper fat skin 5.png' },
      { id: 'mp1_a_upper_set2_vnormal', name: 'Set 2 #normal', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper normal.png' },
      { id: 'mp1_a_upper_set2_vwith_abs', name: 'Set 2 #with abs', src: 'demo-assets/characters/male-pose-1/adv outfit 2 upper with abs.png' },
      { id: 'mp1_a_upper_set3_vdefault', name: 'Set 3', src: 'demo-assets/characters/male-pose-1/adv outfit 3 upper.png' },
      { id: 'mp1_a_upper_set4_v1', name: 'Set 4 #1', src: 'demo-assets/characters/male-pose-1/adv outfit 4 upper 1.png' },
      { id: 'mp1_a_upper_set4_v2', name: 'Set 4 #2', src: 'demo-assets/characters/male-pose-1/adv outfit 4 upper 2.png' },
      { id: 'mp1_a_upper_set4_v3', name: 'Set 4 #3', src: 'demo-assets/characters/male-pose-1/adv outfit 4 upper 3.png' },
      { id: 'mp1_a_upper_set5_vfat_skin_1', name: 'Set 5 #fat skin 1', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper fat skin 1.png' },
      { id: 'mp1_a_upper_set5_vfat_skin_2', name: 'Set 5 #fat skin 2', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper fat skin 2.png' },
      { id: 'mp1_a_upper_set5_vfat_skin_3', name: 'Set 5 #fat skin 3', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper fat skin 3.png' },
      { id: 'mp1_a_upper_set5_vfat_skin_4', name: 'Set 5 #fat skin 4', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper fat skin 4.png' },
      { id: 'mp1_a_upper_set5_vfat_skin_5', name: 'Set 5 #fat skin 5', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper fat skin 5.png' },
      { id: 'mp1_a_upper_set5_vnormal', name: 'Set 5 #normal', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper normal.png' },
      { id: 'mp1_a_upper_set5_vwith_abs', name: 'Set 5 #with abs', src: 'demo-assets/characters/male-pose-1/adv outfit 5 upper with abs.png' }
    ],
    body: [
      { id: 'mp1_body', name: 'Default', src: 'demo-assets/characters/male-pose-1/body 1.png' }
    ],
    face_acc: [
      { id: 'mp1_face_acc_none', name: 'None', src: null },
      { id: 'mp1_face_acc_cheek', name: 'Cheek', src: 'demo-assets/characters/male-pose-1/cheek.png' }
    ],
    hair_front: [
      { id: 'mp1_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-1/def hair 1 front.png' },
      { id: 'mp1_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-1/def hair 2 front.png' },
      { id: 'mp1_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-1/def hair 3 front.png' },
      { id: 'mp1_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-1/def hair 4 front.png' },
      { id: 'mp1_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-1/def hair 5 front.png' },
      { id: 'mp1_a_hair_front_set1_vdefault', name: 'Outfit Set 1', src: 'demo-assets/characters/male-pose-1/adv outfit 1 hair front.png' },
      { id: 'mp1_a_hair_front_set2_vdefault', name: 'Outfit Set 2', src: 'demo-assets/characters/male-pose-1/adv outfit 2 hair front.png' },
      { id: 'mp1_a_hair_front_set3_vdefault', name: 'Outfit Set 3', src: 'demo-assets/characters/male-pose-1/adv outfit 3 hair front.png' },
      { id: 'mp1_a_hair_front_set4_vdefault', name: 'Outfit Set 4', src: 'demo-assets/characters/male-pose-1/adv outfit 4 hair front.png' },
      { id: 'mp1_a_hair_front_set5_vdefault', name: 'Outfit Set 5', src: 'demo-assets/characters/male-pose-1/adv outfit 5 hair front.png' }
    ],
    hair_side: [
      { id: 'mp1_hair_side_none', name: 'None', src: null },
      { id: 'mp1_hair_side_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-1/def hair 1 side.png' },
      { id: 'mp1_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-1/def hair 2 side.png' },
      { id: 'mp1_hair_side_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-1/def hair 3 side.png' },
      { id: 'mp1_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-1/def hair 4 side.png' },
      { id: 'mp1_hair_side_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-1/def hair 5 side.png' }
    ],
    ears: [
      { id: 'mp1_ears', name: 'Default', src: 'demo-assets/characters/male-pose-1/ear 1.png' }
    ],
    brows: [
      { id: 'mp1_brows_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-1/exp 1 eyebrow.png' },
      { id: 'mp1_brows_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-1/exp 2 eyebrow.png' },
      { id: 'mp1_brows_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-1/exp 3 eyebrow.png' },
      { id: 'mp1_brows_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-1/exp 4 eyebrow.png' }
    ],
    eyes: [
      { id: 'mp1_eyes_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-1/exp 1 eyes.png' },
      { id: 'mp1_eyes_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-1/exp 2 eyes.png' },
      { id: 'mp1_eyes_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-1/exp 3 eyes.png' },
      { id: 'mp1_eyes_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-1/exp 4 eyes.png' }
    ],
    mouth: [
      { id: 'mp1_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-1/exp 1 mouth.png' },
      { id: 'mp1_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-1/exp 2 mouth.png' },
      { id: 'mp1_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-1/exp 3 mouth.png' },
      { id: 'mp1_mouth_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-1/exp 4 mouth.png' }
    ],
    head: [
      { id: 'mp1_head_normal', name: 'Normal', src: 'demo-assets/characters/male-pose-1/head normal 1.png' },
      { id: 'mp1_head_fat', name: 'Fat', src: 'demo-assets/characters/male-pose-1/head fat 1.png' },
      { id: 'mp1_head_narrow', name: 'Narrow', src: 'demo-assets/characters/male-pose-1/head narrow 1.png' },
      { id: 'mp1_head_square', name: 'Square', src: 'demo-assets/characters/male-pose-1/head square 1.png' }
    ],
    nose: [
      { id: 'mp1_nose_v1', name: '#1', src: 'demo-assets/characters/male-pose-1/nose 1.png' },
      { id: 'mp1_nose_v2', name: '#2', src: 'demo-assets/characters/male-pose-1/nose 2.png' }
    ],
  },

  // ----- Male Pose 2 (male-pose-2) -----
  mp2: {
    outfit_bottom: [
      { id: 'mp2_adv_bottom_none', name: 'None', src: null },
      { id: 'mp2_a_bottom_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 1 bottom.png' },
      { id: 'mp2_a_bottom_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 2 bottom.png' },
      { id: 'mp2_a_bottom_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 3 bottom.png' },
      { id: 'mp2_a_bottom_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 4 bottom.png' },
      { id: 'mp2_a_bottom_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 5 bottom.png' }
    ],
    hair_back: [
      { id: 'mp2_adv_hair_back_none', name: 'None', src: null },
      { id: 'mp2_a_hair_back_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 1 hair back.png' },
      { id: 'mp2_a_hair_back_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 2 hair back.png' },
      { id: 'mp2_a_hair_back_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 3 hair back.png' },
      { id: 'mp2_a_hair_back_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 4 hair back.png' },
      { id: 'mp2_a_hair_back_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 5 hair back.png' }
    ],

    shoes: [
      { id: 'mp2_adv_shoes_none', name: 'None', src: null },
      { id: 'mp2_a_shoes_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 1 shoes.png' },
      { id: 'mp2_a_shoes_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 2 shoes.png' },
      { id: 'mp2_a_shoes_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 3 shoes.png' },
      { id: 'mp2_a_shoes_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 4 shoes.png' },
      { id: 'mp2_a_shoes_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 5 shoes.png' }
    ],
    outfit_upper: [
      { id: 'mp2_adv_upper_none', name: 'None', src: null },
      { id: 'mp2_a_upper_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 1 upper.png' },
      { id: 'mp2_a_upper_set2_vfat_skin_1', name: 'Set 2 #fat skin 1', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper fat skin 1.png' },
      { id: 'mp2_a_upper_set2_vfat_skin_2', name: 'Set 2 #fat skin 2', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper fat skin 2.png' },
      { id: 'mp2_a_upper_set2_vfat_skin_3', name: 'Set 2 #fat skin 3', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper fat skin 3.png' },
      { id: 'mp2_a_upper_set2_vfat_skin_4', name: 'Set 2 #fat skin 4', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper fat skin 4.png' },
      { id: 'mp2_a_upper_set2_vfat_skin_5', name: 'Set 2 #fat skin 5', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper fat skin 5.png' },
      { id: 'mp2_a_upper_set2_vnormal', name: 'Set 2 #normal', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper normal.png' },
      { id: 'mp2_a_upper_set2_vwith_abs', name: 'Set 2 #with abs', src: 'demo-assets/characters/male-pose-2/adv outfit 2 upper with abs.png' },
      { id: 'mp2_a_upper_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-2/adv outfit 3 upper.png' },
      { id: 'mp2_a_upper_set4_v1', name: 'Set 4 #1', src: 'demo-assets/characters/male-pose-2/adv outfit 4 upper 1.png' },
      { id: 'mp2_a_upper_set4_v2', name: 'Set 4 #2', src: 'demo-assets/characters/male-pose-2/adv outfit 4 upper 2.png' },
      { id: 'mp2_a_upper_set4_v3', name: 'Set 4 #3', src: 'demo-assets/characters/male-pose-2/adv outfit 4 upper 3.png' },
      { id: 'mp2_a_upper_set5_vfat_skin_1', name: 'Set 5 #fat skin 1', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper fat skin 1.png' },
      { id: 'mp2_a_upper_set5_vfat_skin_2', name: 'Set 5 #fat skin 2', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper fat skin 2.png' },
      { id: 'mp2_a_upper_set5_vfat_skin_3', name: 'Set 5 #fat skin 3', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper fat skin 3.png' },
      { id: 'mp2_a_upper_set5_vfat_skin_4', name: 'Set 5 #fat skin 4', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper fat skin 4.png' },
      { id: 'mp2_a_upper_set5_vfat_skin_5', name: 'Set 5 #fat skin 5', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper fat skin 5.png' },
      { id: 'mp2_a_upper_set5_vnormal', name: 'Set 5 #normal', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper normal.png' },
      { id: 'mp2_a_upper_set5_vwith_abs', name: 'Set 5 #with abs', src: 'demo-assets/characters/male-pose-2/adv outfit 5 upper with abs.png' }
    ],
    body: [
      { id: 'mp2_body', name: 'Default', src: 'demo-assets/characters/male-pose-2/body 1.png' }
    ],
    face_acc: [
      { id: 'mp2_face_acc_none', name: 'None', src: null },
      { id: 'mp2_face_acc_cheek', name: 'Cheek', src: 'demo-assets/characters/male-pose-2/cheek.png' }
    ],
    hair_front: [
      { id: 'mp2_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-2/def hair 1 front.png' },
      { id: 'mp2_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-2/def hair 2 front.png' },
      { id: 'mp2_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-2/def hair 3 front.png' },
      { id: 'mp2_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-2/def hair 4 front.png' },
      { id: 'mp2_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-2/def hair 5 front.png' },
      { id: 'mp2_a_hair_front_set1_vdefault', name: 'Outfit Set 1', src: 'demo-assets/characters/male-pose-2/adv outfit 1 hair front.png' },
      { id: 'mp2_a_hair_front_set2_vdefault', name: 'Outfit Set 2', src: 'demo-assets/characters/male-pose-2/adv outfit 2 hair front.png' },
      { id: 'mp2_a_hair_front_set3_vdefault', name: 'Outfit Set 3', src: 'demo-assets/characters/male-pose-2/adv outfit 3 hair front.png' },
      { id: 'mp2_a_hair_front_set4_vdefault', name: 'Outfit Set 4', src: 'demo-assets/characters/male-pose-2/adv outfit 4 hair front.png' },
      { id: 'mp2_a_hair_front_set5_vdefault', name: 'Outfit Set 5', src: 'demo-assets/characters/male-pose-2/adv outfit 5 hair front.png' }
    ],
    hair_side: [
      { id: 'mp2_hair_side_none', name: 'None', src: null },
      { id: 'mp2_hair_side_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-2/def hair 1 side.png' },
      { id: 'mp2_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-2/def hair 2 side.png' },
      { id: 'mp2_hair_side_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-2/def hair 3 side.png' },
      { id: 'mp2_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-2/def hair 4 side.png' },
      { id: 'mp2_hair_side_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-2/def hair 5 side.png' }
    ],
    ears: [
      { id: 'mp2_ears', name: 'Default', src: 'demo-assets/characters/male-pose-2/ear 1.png' }
    ],
    brows: [
      { id: 'mp2_brows_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-2/exp 1 eyebrow.png' },
      { id: 'mp2_brows_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-2/exp 2 eyebrow.png' },
      { id: 'mp2_brows_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-2/exp 3 eyebrow.png' },
      { id: 'mp2_brows_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-2/exp 4 eyebrow.png' }
    ],
    eyes: [
      { id: 'mp2_eyes_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-2/exp 1 eyes.png' },
      { id: 'mp2_eyes_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-2/exp 2 eyes.png' },
      { id: 'mp2_eyes_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-2/exp 3 eyes.png' },
      { id: 'mp2_eyes_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-2/exp 4 eyes.png' }
    ],
    mouth: [
      { id: 'mp2_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-2/exp 1 mouth.png' },
      { id: 'mp2_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-2/exp 2 mouth.png' },
      { id: 'mp2_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-2/exp 3 mouth.png' },
      { id: 'mp2_mouth_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-2/exp 4 mouth.png' }
    ],
    head: [
      { id: 'mp2_head_normal', name: 'Normal', src: 'demo-assets/characters/male-pose-2/head normal 1.png' },
      { id: 'mp2_head_fat', name: 'Fat', src: 'demo-assets/characters/male-pose-2/head fat 1.png' },
      { id: 'mp2_head_narrow', name: 'Narrow', src: 'demo-assets/characters/male-pose-2/head narrow 1.png' },
      { id: 'mp2_head_square', name: 'Square', src: 'demo-assets/characters/male-pose-2/head square 1.png' }
    ],
    nose: [
      { id: 'mp2_nose_v1', name: '#1', src: 'demo-assets/characters/male-pose-2/nose 1.png' },
      { id: 'mp2_nose_v2', name: '#2', src: 'demo-assets/characters/male-pose-2/nose 2.png' }
    ],
  },
  // ----- Male Pose 3 (male-pose-3) -----
  mp3: {
    outfit_bottom: [
      { id: 'mp3_adv_bottom_none', name: 'None', src: null },
      { id: 'mp3_a_bottom_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 1 bottom.png' },
      { id: 'mp3_a_bottom_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 2 bottom.png' },
      { id: 'mp3_a_bottom_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 3 bottom.png' },
      { id: 'mp3_a_bottom_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 4 bottom.png' },
      { id: 'mp3_a_bottom_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 5 bottom.png' }
    ],
    hair_back: [
      { id: 'mp3_adv_hair_back_none', name: 'None', src: null },
      { id: 'mp3_a_hair_back_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 1 hair back.png' },
      { id: 'mp3_a_hair_back_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 2 hair back.png' },
      { id: 'mp3_a_hair_back_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 3 hair back.png' },
      { id: 'mp3_a_hair_back_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 4 hair back.png' },
      { id: 'mp3_a_hair_back_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 5 hair back.png' }
    ],

    shoes: [
      { id: 'mp3_adv_shoes_none', name: 'None', src: null },
      { id: 'mp3_a_shoes_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 1 shoes.png' },
      { id: 'mp3_a_shoes_set2_vdefault', name: 'Set 2 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 2 shoes.png' },
      { id: 'mp3_a_shoes_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 3 shoes.png' },
      { id: 'mp3_a_shoes_set4_vdefault', name: 'Set 4 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 4 shoes.png' },
      { id: 'mp3_a_shoes_set5_vdefault', name: 'Set 5 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 5 shoes.png' }
    ],
    outfit_upper: [
      { id: 'mp3_adv_upper_none', name: 'None', src: null },
      { id: 'mp3_a_upper_set1_vdefault', name: 'Set 1 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 1 upper.png' },
      { id: 'mp3_a_upper_set2_vfat_skin_1', name: 'Set 2 #fat skin 1', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper fat skin 1.png' },
      { id: 'mp3_a_upper_set2_vfat_skin_2', name: 'Set 2 #fat skin 2', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper fat skin 2.png' },
      { id: 'mp3_a_upper_set2_vfat_skin_3', name: 'Set 2 #fat skin 3', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper fat skin 3.png' },
      { id: 'mp3_a_upper_set2_vfat_skin_4', name: 'Set 2 #fat skin 4', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper fat skin 4.png' },
      { id: 'mp3_a_upper_set2_vfat_skin_5', name: 'Set 2 #fat skin 5', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper fat skin 5.png' },
      { id: 'mp3_a_upper_set2_vnormal', name: 'Set 2 #normal', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper normal.png' },
      { id: 'mp3_a_upper_set2_vwith_abs', name: 'Set 2 #with abs', src: 'demo-assets/characters/male-pose-3/adv outfit 2 upper with abs.png' },
      { id: 'mp3_a_upper_set3_vdefault', name: 'Set 3 #default', src: 'demo-assets/characters/male-pose-3/adv outfit 3 upper.png' },
      { id: 'mp3_a_upper_set4_v1', name: 'Set 4 #1', src: 'demo-assets/characters/male-pose-3/adv outfit 4 upper 1.png' },
      { id: 'mp3_a_upper_set4_v2', name: 'Set 4 #2', src: 'demo-assets/characters/male-pose-3/adv outfit 4 upper 2.png' },
      { id: 'mp3_a_upper_set4_v3', name: 'Set 4 #3', src: 'demo-assets/characters/male-pose-3/adv outfit 4 upper 3.png' },
      { id: 'mp3_a_upper_set5_vfat_skin_1', name: 'Set 5 #fat skin 1', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper fat skin 1.png' },
      { id: 'mp3_a_upper_set5_vfat_skin_2', name: 'Set 5 #fat skin 2', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper fat skin 2.png' },
      { id: 'mp3_a_upper_set5_vfat_skin_3', name: 'Set 5 #fat skin 3', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper fat skin 3.png' },
      { id: 'mp3_a_upper_set5_vfat_skin_4', name: 'Set 5 #fat skin 4', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper fat skin 4.png' },
      { id: 'mp3_a_upper_set5_vfat_skin_5', name: 'Set 5 #fat skin 5', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper fat skin 5.png' },
      { id: 'mp3_a_upper_set5_vnormal', name: 'Set 5 #normal', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper normal.png' },
      { id: 'mp3_a_upper_set5_vwith_abs', name: 'Set 5 #with abs', src: 'demo-assets/characters/male-pose-3/adv outfit 5 upper with abs.png' }
    ],
    body: [
      { id: 'mp3_body', name: 'Default', src: 'demo-assets/characters/male-pose-3/body 1.png' }
    ],
    face_acc: [
      { id: 'mp3_face_acc_none', name: 'None', src: null },
      { id: 'mp3_face_acc_cheek', name: 'Cheek', src: 'demo-assets/characters/male-pose-3/cheek.png' }
    ],
    hair_front: [
      { id: 'mp3_hair_front_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-3/def hair 1 front.png' },
      { id: 'mp3_hair_front_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-3/def hair 2 front.png' },
      { id: 'mp3_hair_front_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-3/def hair 3 front.png' },
      { id: 'mp3_hair_front_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-3/def hair 4 front.png' },
      { id: 'mp3_hair_front_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-3/def hair 5 front.png' },
      { id: 'mp3_a_hair_front_set1_vdefault', name: 'Outfit Set 1', src: 'demo-assets/characters/male-pose-3/adv outfit 1 hair front.png' },
      { id: 'mp3_a_hair_front_set2_vdefault', name: 'Outfit Set 2', src: 'demo-assets/characters/male-pose-3/adv outfit 2 hair front.png' },
      { id: 'mp3_a_hair_front_set3_vdefault', name: 'Outfit Set 3', src: 'demo-assets/characters/male-pose-3/adv outfit 3 hair front.png' },
      { id: 'mp3_a_hair_front_set4_vdefault', name: 'Outfit Set 4', src: 'demo-assets/characters/male-pose-3/adv outfit 4 hair front.png' },
      { id: 'mp3_a_hair_front_set5_vdefault', name: 'Outfit Set 5', src: 'demo-assets/characters/male-pose-3/adv outfit 5 hair front.png' }
    ],
    hair_side: [
      { id: 'mp3_hair_side_none', name: 'None', src: null },
      { id: 'mp3_hair_side_s1', name: 'Style 1', src: 'demo-assets/characters/male-pose-3/def hair 1 side.png' },
      { id: 'mp3_hair_side_s2', name: 'Style 2', src: 'demo-assets/characters/male-pose-3/def hair 2 side.png' },
      { id: 'mp3_hair_side_s3', name: 'Style 3', src: 'demo-assets/characters/male-pose-3/def hair 3 side.png' },
      { id: 'mp3_hair_side_s4', name: 'Style 4', src: 'demo-assets/characters/male-pose-3/def hair 4 side.png' },
      { id: 'mp3_hair_side_s5', name: 'Style 5', src: 'demo-assets/characters/male-pose-3/def hair 5 side.png' }
    ],
    ears: [
      { id: 'mp3_ears', name: 'Default', src: 'demo-assets/characters/male-pose-3/ear 1.png' }
    ],
    brows: [
      { id: 'mp3_brows_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-3/exp 1 eyebrow.png' },
      { id: 'mp3_brows_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-3/exp 2 eyebrow.png' },
      { id: 'mp3_brows_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-3/exp 3 eyebrow.png' },
      { id: 'mp3_brows_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-3/exp 4 eyebrow.png' }
    ],
    eyes: [
      { id: 'mp3_eyes_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-3/exp 1 eyes.png' },
      { id: 'mp3_eyes_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-3/exp 2 eyes.png' },
      { id: 'mp3_eyes_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-3/exp 3 eyes.png' },
      { id: 'mp3_eyes_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-3/exp 4 eyes.png' }
    ],
    mouth: [
      { id: 'mp3_mouth_e1', name: 'Exp 1', src: 'demo-assets/characters/male-pose-3/exp 1 mouth.png' },
      { id: 'mp3_mouth_e2', name: 'Exp 2', src: 'demo-assets/characters/male-pose-3/exp 2 mouth.png' },
      { id: 'mp3_mouth_e3', name: 'Exp 3', src: 'demo-assets/characters/male-pose-3/exp 3 mouth.png' },
      { id: 'mp3_mouth_e4', name: 'Exp 4', src: 'demo-assets/characters/male-pose-3/exp 4 mouth.png' }
    ],
    head: [
      { id: 'mp3_head_normal', name: 'Normal', src: 'demo-assets/characters/male-pose-3/head normal 1.png' }
    ],
    nose: [
      { id: 'mp3_nose_v1', name: '#1', src: 'demo-assets/characters/male-pose-3/nose 1.png' },
      { id: 'mp3_nose_v2', name: '#2', src: 'demo-assets/characters/male-pose-3/nose 2.png' }
    ],
  }
};

// ==================== OUTFIT SET BUNDLES ====================
// Defines which asset IDs get applied to which layers when a set is selected.
// The key '_set<N>_' pattern in asset IDs is used for auto-matching.
// bundledCategories lists the layers that get overridden when a set is active.
const OUTFIT_SET_BUNDLES = {
  // Male poses: 5 outfit sets each
  male_pose_1: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'shoes', 'hair_front', 'hair_back', 'hair_side'],
    sets: [
      { id: 'set_1', name: 'Set 1', setNum: '1', thumbnail: 'demo-assets/characters/male-pose-1/adv outfit 1 upper.png' },
      { id: 'set_2', name: 'Set 2', setNum: '2', thumbnail: 'demo-assets/characters/male-pose-1/adv outfit 2 upper normal.png' },
      { id: 'set_3', name: 'Set 3', setNum: '3', thumbnail: 'demo-assets/characters/male-pose-1/adv outfit 3 upper.png' },
      { id: 'set_4', name: 'Set 4', setNum: '4', thumbnail: 'demo-assets/characters/male-pose-1/adv outfit 4 upper 1.png' },
      { id: 'set_5', name: 'Set 5', setNum: '5', thumbnail: 'demo-assets/characters/male-pose-1/adv outfit 5 upper normal.png' }
    ]
  },
  male_pose_2: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'shoes', 'hair_front', 'hair_back', 'hair_side'],
    sets: [
      { id: 'set_1', name: 'Set 1', setNum: '1', thumbnail: 'demo-assets/characters/male-pose-2/adv outfit 1 upper.png' },
      { id: 'set_2', name: 'Set 2', setNum: '2', thumbnail: 'demo-assets/characters/male-pose-2/adv outfit 2 upper normal.png' },
      { id: 'set_3', name: 'Set 3', setNum: '3', thumbnail: 'demo-assets/characters/male-pose-2/adv outfit 3 upper.png' },
      { id: 'set_4', name: 'Set 4', setNum: '4', thumbnail: 'demo-assets/characters/male-pose-2/adv outfit 4 upper 1.png' },
      { id: 'set_5', name: 'Set 5', setNum: '5', thumbnail: 'demo-assets/characters/male-pose-2/adv outfit 5 upper normal.png' }
    ]
  },
  male_pose_3: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'shoes', 'hair_front', 'hair_back', 'hair_side'],
    sets: [
      { id: 'set_1', name: 'Set 1', setNum: '1', thumbnail: 'demo-assets/characters/male-pose-3/adv outfit 1 upper.png' },
      { id: 'set_2', name: 'Set 2', setNum: '2', thumbnail: 'demo-assets/characters/male-pose-3/adv outfit 2 upper normal.png' },
      { id: 'set_3', name: 'Set 3', setNum: '3', thumbnail: 'demo-assets/characters/male-pose-3/adv outfit 3 upper.png' },
      { id: 'set_4', name: 'Set 4', setNum: '4', thumbnail: 'demo-assets/characters/male-pose-3/adv outfit 4 upper 1.png' },
      { id: 'set_5', name: 'Set 5', setNum: '5', thumbnail: 'demo-assets/characters/male-pose-3/adv outfit 5 upper normal.png' }
    ]
  },
  // Gaming poses: 5 sim outfit sets each
  female_gaming: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'outfit_outer'],
    sets: [
      { id: 'sim_set_1', name: 'Sim Set 1', setNum: '1', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'sim_set_2', name: 'Sim Set 2', setNum: '2', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'sim_set_3', name: 'Sim Set 3', setNum: '3', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'sim_set_4', name: 'Sim Set 4', setNum: '4', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'sim_set_5', name: 'Sim Set 5', setNum: '5', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 5 upper 1.png' }
    ]
  },
  female_gaming_tilted: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'outfit_outer'],
    sets: [
      { id: 'sim_set_1', name: 'Sim Set 1', setNum: '1', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'sim_set_2', name: 'Sim Set 2', setNum: '2', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'sim_set_3', name: 'Sim Set 3', setNum: '3', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'sim_set_4', name: 'Sim Set 4', setNum: '4', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'sim_set_5', name: 'Sim Set 5', setNum: '5', thumbnail: 'demo-assets/characters/female-gaming-pose/sim outfit 5 upper 1.png' }
    ]
  },
  male_gaming: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'outfit_outer'],
    sets: [
      { id: 'sim_set_1', name: 'Sim Set 1', setNum: '1', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'sim_set_2', name: 'Sim Set 2', setNum: '2', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'sim_set_3', name: 'Sim Set 3', setNum: '3', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'sim_set_4', name: 'Sim Set 4', setNum: '4', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'sim_set_5', name: 'Sim Set 5', setNum: '5', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 5 upper 1.png' }
    ]
  },
  male_gaming_tilted: {
    bundledCategories: ['outfit_upper', 'outfit_bottom', 'outfit_outer'],
    sets: [
      { id: 'sim_set_1', name: 'Sim Set 1', setNum: '1', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 1 upper 1.png' },
      { id: 'sim_set_2', name: 'Sim Set 2', setNum: '2', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 2 upper 1.png' },
      { id: 'sim_set_3', name: 'Sim Set 3', setNum: '3', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 3 upper 1.png' },
      { id: 'sim_set_4', name: 'Sim Set 4', setNum: '4', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 4 upper 1.png' },
      { id: 'sim_set_5', name: 'Sim Set 5', setNum: '5', thumbnail: 'demo-assets/characters/male-gaming-pose/sim outfit 5 upper 1.png' }
    ]
  }
};
// ==================== HAIR FRONT → SIDE/BACK SYNC ====================
// Defines which categories auto-sync when hair_front changes for each pose.
// Uses style number suffix matching: extract `_s<N>` from front ID,
// find matching `_s<N>` in target categories. If no match, set to 'None'.
const HAIR_FRONT_SYNC_TARGETS = {
  // Male poses: front → side + back (back is outfit-set only, generic styles will correctly fallback to None)
  male_pose_1: { targets: ['hair_side', 'hair_back'] },
  male_pose_2: { targets: ['hair_side', 'hair_back'] },
  male_pose_3: { targets: ['hair_side', 'hair_back'] },
  // Female gaming: front → side + back
  female_gaming: { targets: ['hair_side', 'hair_back'] },
  female_gaming_tilted: { targets: ['hair_back'] },  // tilted has no hair_side
  // Male gaming: front → side
  male_gaming: { targets: ['hair_side'] },
  male_gaming_tilted: { targets: ['hair_side'] },
  // They Don't Bite: front → side + back
  female_tdnb: { targets: ['hair_side', 'hair_back'] },
  // I Survived AX: front → side + back
  female_isa: { targets: ['hair_side', 'hair_back'] }
};

// ==================== MERGE INTO CHARACTER_CONFIG ====================
// Call this at startup to merge new poses into the existing config
function mergeNewPoses() {
  // Add new poses
  CHARACTER_CONFIG.poses.push(...NEW_CHARACTER_POSES);

  // Merge tilted sub-pose assets: tilted re-uses body/outfit from normal, overrides face/head/hair
  // Only inherit body/outfit categories from normal — don't inherit face/hair categories
  // that the tilted definition doesn't explicitly provide (they won't match visually).
  const TILTED_INHERITABLE = [
    'body', 'outfit_upper', 'outfit_bottom', 'outfit_outer', 'outfit_full',
    'outfit_acc', 'shoes', 'socks', 'handheld', 'extras'
  ];

  const tiltedMerges = [
    { tilted: 'fgp_tilted', normal: 'fgp_normal' },
    { tilted: 'mgp_tilted', normal: 'mgp_normal' }
  ];

  for (const { tilted, normal } of tiltedMerges) {
    if (NEW_CHARACTER_ASSETS[tilted] && NEW_CHARACTER_ASSETS[normal]) {
      const merged = {};
      // Only inherit body/outfit categories from normal
      for (const [cat, items] of Object.entries(NEW_CHARACTER_ASSETS[normal])) {
        if (TILTED_INHERITABLE.includes(cat)) {
          merged[cat] = [...items];
        }
      }
      // Add all tilted-specific assets (face, head, hair, ears, nose, etc.)
      for (const [cat, items] of Object.entries(NEW_CHARACTER_ASSETS[tilted])) {
        merged[cat] = items;
      }
      NEW_CHARACTER_ASSETS[tilted] = merged;
    }
  }

  // Add all assets (keyed by pose ID, mapped from generated keys)
  const poseKeyMap = {
    'fgp_normal': 'female_gaming',
    'fgp_tilted': 'female_gaming_tilted',
    'mgp_normal': 'male_gaming',
    'mgp_tilted': 'male_gaming_tilted',
    'mp1': 'male_pose_1',
    'mp2': 'male_pose_2',
    'mp3': 'male_pose_3'
  };

  for (const [genKey, poseId] of Object.entries(poseKeyMap)) {
    const assets = NEW_CHARACTER_ASSETS[genKey];
    if (assets) {
      // Move "None" items (src: null) to end of each category array
      // so default selections pick an actual visible asset
      for (const cat of Object.keys(assets)) {
        const items = assets[cat];
        if (items.length > 1) {
          const real = items.filter(a => a.src !== null);
          const none = items.filter(a => a.src === null);
          assets[cat] = [...real, ...none];
        }
      }
      CHARACTER_CONFIG.assets[poseId] = assets;
    }
  }

  // Merge TDNB (They Don't Bite) pose assets from separate config files
  const tdnbPoses = {
    'female_tdnb': typeof TDNB_FEMALE_ASSETS !== 'undefined' ? TDNB_FEMALE_ASSETS : null,
    'male_tdnb': typeof TDNB_MALE_ASSETS !== 'undefined' ? TDNB_MALE_ASSETS : null
  };
  for (const [poseId, assets] of Object.entries(tdnbPoses)) {
    if (assets) {
      // Move "None" items to end of each category
      for (const cat of Object.keys(assets)) {
        const items = assets[cat];
        if (items.length > 1) {
          const real = items.filter(a => a.src !== null);
          const none = items.filter(a => a.src === null);
          assets[cat] = [...real, ...none];
        }
      }
      CHARACTER_CONFIG.assets[poseId] = assets;
    }
  }

  // Merge ISA (I Survived AX) pose assets from separate config files
  const isaPoses = {
    'female_isa': typeof ISA_FEMALE_ASSETS !== 'undefined' ? ISA_FEMALE_ASSETS : null,
    'male_isa': typeof ISA_MALE_ASSETS !== 'undefined' ? ISA_MALE_ASSETS : null
  };
  for (const [poseId, assets] of Object.entries(isaPoses)) {
    if (assets) {
      // Move "None" items to end of each category
      for (const cat of Object.keys(assets)) {
        const items = assets[cat];
        if (items.length > 1) {
          const real = items.filter(a => a.src !== null);
          const none = items.filter(a => a.src === null);
          assets[cat] = [...real, ...none];
        }
      }
      CHARACTER_CONFIG.assets[poseId] = assets;
    }
  }
}
